import Phaser from "phaser";
import { gameConfig } from "./config/gameConfig";

new Phaser.Game(gameConfig);
